module.exports = __webpack_public_path__ + "img/alex_feedback.29a8c35a.svg";